import { render, staticRenderFns } from "./CustomerList080DataTable.vue?vue&type=template&id=4f1f1d98&scoped=true"
import script from "./CustomerList080DataTable.vue?vue&type=script&lang=js"
export * from "./CustomerList080DataTable.vue?vue&type=script&lang=js"
import style0 from "./CustomerList080DataTable.vue?vue&type=style&index=0&id=4f1f1d98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1f1d98",
  null
  
)

export default component.exports